export const WC_API_URL = 'https://api.wealthcompounders.tech/api';
export const WC_API_HEADER_KEY  ='fKVFY41BrQAB6a444kQy7IZA3u9NgcXo';
export const REACT_APP_FIREBASE_VAPID_KEY = 'BKds8y0_cRbfx8IdJ0iVE7h02Z8mTiXqiCWrerNB_oqaeOXXCrQWxn9Q4-WLS8NG-sBB1e4XT2PRqzg_JaLCKyw'